const ENV = process.env.REACT_APP_ENV;
const ROOM = process.env.REACT_APP_ROOM;

// The client installation built by bin/dist.sh syncs solutions from Workix instead of
// authoring them. Its own settings (bin/dist/template/src/settings.js) set this to true.
const IS_LITE = false;

const DOMAIN = "workix.mx";

const IS_PROD = ENV === "prod";
const IS_TEST = ENV === "test" && ROOM;

let APP_URL;
let SERVER_URL;
let REST_SERVER_URL;
let VIEWS_URL;
let LANDING_URL;
let GA_KEY;
let SENTRY_DSN;
let SENTRY_ENVIRONMENT;
let SENTRY_SAMPLE_RATE;
let MICROSOFT_CLIENT_ID;
let GOOGLE_CLIENT_ID;

if (IS_PROD) {
  APP_URL = `https://app.${DOMAIN}`;
  SERVER_URL = `https://internal-api.${DOMAIN}`;
  REST_SERVER_URL = `https://api.${DOMAIN}`;
  VIEWS_URL = `https://views.${DOMAIN}`;
  LANDING_URL = `https://${DOMAIN}`;
  GA_KEY = "G-0000000000";
  SENTRY_DSN = "https://5280cf8161a2811bda1d656334a8dca9@o4505944161779712.ingest.sentry.io/4505944207261696";
  SENTRY_ENVIRONMENT = "production";
  SENTRY_SAMPLE_RATE = 0.25;
  MICROSOFT_CLIENT_ID = "f74335a6-8303-414f-8c51-17bc937578ab";
  GOOGLE_CLIENT_ID = "403772658120-2pjhgj9tofptfanl0aeggie1fnpkl4se.apps.googleusercontent.com"
}
else if (IS_TEST) {
  APP_URL = `https://test-${ROOM}.${DOMAIN}`;
  SERVER_URL = `https://test-api-${ROOM}.${DOMAIN}`;
  REST_SERVER_URL = `https://test-rest-${ROOM}.${DOMAIN}`;
  VIEWS_URL = `https://test-views-${ROOM}.${DOMAIN}`;
  LANDING_URL = `https://${DOMAIN}`;
  GA_KEY = "G-0000000000";
  SENTRY_DSN = "https://5280cf8161a2811bda1d656334a8dca9@o4505944161779712.ingest.sentry.io/4505944207261696";
  SENTRY_ENVIRONMENT = "test";
  SENTRY_SAMPLE_RATE = 0.25;
  MICROSOFT_CLIENT_ID = "f74335a6-8303-414f-8c51-17bc937578ab";
  GOOGLE_CLIENT_ID = "403772658120-2pjhgj9tofptfanl0aeggie1fnpkl4se.apps.googleusercontent.com"
}
else {
  APP_URL = "http://localhost:3003";
  SERVER_URL = "http://localhost:8008";
  REST_SERVER_URL = "http://localhost:8011";
  VIEWS_URL = "http://localhost:3001";
  LANDING_URL = "http://localhost:5005";
  GA_KEY = "G-0000000000";
  SENTRY_DSN = "";
  SENTRY_SAMPLE_RATE = 0;
  MICROSOFT_CLIENT_ID = "f74335a6-8303-414f-8c51-17bc937578ab";
  GOOGLE_CLIENT_ID = "403772658120-2pjhgj9tofptfanl0aeggie1fnpkl4se.apps.googleusercontent.com"
}

const SENTRY_RELEASE = process.env.REACT_APP_SENTRY_RELEASE || "dev";

const GRAPH_URL = SERVER_URL + "/graphql";
const API_URL = SERVER_URL + "/api";
// The collections API (/api/v1) is served by seedbot-rest on its own host.
const REST_URL = REST_SERVER_URL + "/api";

const WS_URL =
  (new URL(SERVER_URL).protocol === "https:" ? "wss:" : "ws:") +
  "//" +
  new URL(SERVER_URL).host +
  "/ws";

export {
  IS_PROD, IS_LITE, APP_URL, SERVER_URL, LANDING_URL, VIEWS_URL, GRAPH_URL, API_URL, REST_URL, WS_URL,
  MICROSOFT_CLIENT_ID, GOOGLE_CLIENT_ID, GA_KEY,
  SENTRY_DSN, SENTRY_ENVIRONMENT, SENTRY_RELEASE, SENTRY_SAMPLE_RATE
};